import React, { FC } from 'react';
import InfoOutline from '@rsuite/icons/InfoOutline';
import { Dropdown } from 'rsuite';
import { LinkComponent } from '../LinkComponent';
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../../../config/environmentConfig';

export const HeaderSupport: FC = () => {
	const { t } = useTranslation();

	return (
		<div className="top-bar-support me-5">
			<Dropdown
				icon={<InfoOutline />}
				noCaret
				placement="bottomEnd"
				className="top-bar-icon"
			>
				<div className="border-bottom px-5 py-3 d-flex align-items-center">
						Support Information
				</div>

				<div className="ps-5 py-5">
					<LinkComponent text={t('MENU.DOCUMENTATION')} link={BASE_URL.DOCS_URL} />
				</div>

			</Dropdown>
		</div>
	);
};